import { Injectable } from '@angular/core';

import { SignToken, SignTokenBrowserRegister } from '../../sign.model';

import { selectorTypes, TokenType } from './selector.model';

@Injectable()
export class ApTokenSelectorService {
    public static getBrowserRegisterSelector(): TokenType {
        return selectorTypes.find((tokenType) => tokenType.name === SignTokenBrowserRegister);
    }

    public static createSelector(policy: SignToken[][]): TokenType[] {
        const supportedTokens = Object.keys(SignToken);
        return policy
            .filter((tokens) => ApTokenSelectorService.areSupported(tokens))
            .sort((t1, t2) => supportedTokens.indexOf(t1[0]) - supportedTokens.indexOf(t2[0]))
            .map((tokens) => ApTokenSelectorService.getTokenType(tokens));
    }

    public static getTokenType(tokens: SignToken[]): TokenType {
        let foundTokenType = selectorTypes.find(
            (tokenType) =>
                tokenType.ids.length === tokens.length && tokens.reduce((equal, token) => equal && tokenType.ids.indexOf(token) >= 0, true)
        );
        return Object.assign({}, foundTokenType);
    }

    private static areSupported(tokens: SignToken[]): boolean {
        const supportedTokens = Object.keys(SignToken);
        return tokens.reduce((available, token) => available && supportedTokens.indexOf(token) >= 0, true);
    }
}
